import { useQuery, useMutation } from 'react-query';
import { LoggedHoursPublicReport } from '@api/LoggedHoursPublicReport';
import { onDefaultError } from '../helpers/commonHelpers';
// Records

const useLoggedHoursReport = (onSuccess, onError = onDefaultError) => {
  return useMutation(
    (params) => LoggedHoursPublicReport.listReport(params),
    {
      onSuccess,
      onError
    }
  );
};

const useGetAllProjects = (onSuccess, onError = onDefaultError) => {
  return useQuery('project-list', LoggedHoursPublicReport.projectListReport, {
    onSuccess,
    onError
  });
};

const useGetAllSprints = (params, onSuccess, onError = onDefaultError) => {
  const isEnabled = params?.project_id ? true : false;
  return useQuery(['sprint-list', [params]], () => LoggedHoursPublicReport.sprintListReport(params), {
    onSuccess,
    keepPreviousData: true,
    onError,
    enabled: isEnabled
  });
};

export {
  useLoggedHoursReport,
  useGetAllProjects,
  useGetAllSprints
};